import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import _ from 'lodash'
import React from 'react'

import calidad from '../../../../../logo/calidad.png'
import plantilla from '../../../../../logo/plantilla_encabezado_reportes_laridae.png'
import { estilos } from '../GenerarPdf/styles'

const styles = StyleSheet.create(estilos)

/* Funcion para Generar reportes en PDF

Props:
info, objeto que contiene
}
  titulo: 'Detalle de Mercaderia Fumigada',
  subtitulo: 'Entre fechas'
  version: 'Version de Laridae'
}
fields, arreglo de objetos
    {
      name: 'cartaDePorte',
      label: 'Carta de Porte',
      width: '70'
    }
data, arreglo de objetos
TODO: Ancho de columnas automatico
*/

const renderTitulo = ({ field, key }) => {
  return (
    <View style={[styles.tableCol, { width: field.width, fontWeight: 'bold', fontSize: '24px', backgroundColor: '#00305c' }]}>
      <Text style={styles.tableTituloCell}>{field.mantenerCase === undefined ? field.label : field.mantenerCase ? field.label : _.startCase(field.label)}</Text>
    </View>
  )
}

const renderTitulos = (fields = null) => {
  return (
    fields.map((field) => {
      return renderTitulo({ field })
    })
  )
}

const renderField = ({ field, value }) => {
  if (typeof (value) === 'string' || typeof (value) === 'number') {
    return (
      <View style={[styles.tableCol, { width: field.width }]}>
        <Text style={styles.tableCell}>{value}</Text>
      </View>
    )
  } else if (value === null) {
    return (
      <View style={[styles.tableCol, { width: field.width }]}>
        <Text style={styles.tableCell}>{'_____'}</Text>
      </View>
    )
  }
  // moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

const renderFields = (data, fields = null) => {
  return (
    fields
      .map((field) => {
        return renderField({ field, value: data[field.name] })
      })
  )
}

const GenerarPdf = (props) => {
  const info = props.info || {}
  const fields = props.fields || []
  const data = props.data
  return (
    <Document
      author='Terminal Quequén S.A.'
      subject='Reportes de Laridae 7'
      title={info.titulo || 'Reporte'}
    >
      <Page size='A4' orientation={props.orientation} style={styles.page} wrap>
        <Image src={plantilla} style={styles.logo} fixed />
        {info.titulo && <Text style={styles.title}>
          {info.titulo}
        </Text>}
        {info.subtitulo && <Text style={styles.subtitle}>
          {info.subtitulo}
        </Text>}
        <View style={styles.table}>
          <View style={styles.tableRow} wrap={false}>
            {renderTitulos(fields)}
          </View>
          {data
            ? data.map((array) => (
              array ? array.map((data, key) => {
                let fondo = styles.tableRow.backgroundColor
                if (key % 2 === 0) { fondo = '#F2F2F2' }
                return (
                  <View style={[styles.tableRow, { backgroundColor: fondo }]} wrap={false}>
                    {renderFields(data, fields)}
                  </View>
                )
              }) : null
            ))
            : ''}
        </View>
        {info.total && <Text style={styles.total}>
          {info.total}
        </Text>}
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        />
        {info.version &&
          <Text
            style={styles.version}
            fixed
          >{info.version}
          </Text>}
        <Image
          src={calidad}
          style={styles.footerLogo}
          fixed />
      </Page>
    </Document>
  )
}

export default GenerarPdf
